import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const secondary = (params) => primaryButtonHover(params);

export default secondary;
